module.exports = __webpack_public_path__ + "files/6b8300d4d1a71ca3aaa6829983f51930.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./non_npm_dependencies/google-fonts/fonts/Roboto-Slab-regular.svg
 ** module id = 866
 ** module chunks = 0
 **/